module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-ExtraLightItalic.woff2?3635f9d09fb206723f3c052e3f6edda1";